import { z } from 'zod';
import { operatingHoursSchema } from '../booking.js';
import { nonEmptyTrimmed, uuidSchema } from './common.js';
export const locationSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    address: z.string(),
    operatingHours: operatingHoursSchema.nullable(),
    sort: z.number().int(),
    isActive: z.boolean(),
    createdAt: z.string(),
});
export const locationCreateSchema = z.object({
    name: nonEmptyTrimmed(80),
    address: z.string().trim().max(200).default(''),
});
// operatingHours explicit null means "inherit workspace hours".
export const locationUpdateSchema = z.object({
    name: nonEmptyTrimmed(80).optional(),
    address: z.string().trim().max(200).optional(),
    operatingHours: operatingHoursSchema.nullable().optional(),
    isActive: z.boolean().optional(),
    sort: z.number().int().min(0).optional(),
});
export const locationsListResponseSchema = z.object({
    items: z.array(locationSchema),
});
//# sourceMappingURL=locations.js.map